import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import FeatureCards from './components/FeatureCards';
import EditorialSection from './components/EditorialSection';
import ReviewSection from './components/ReviewSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://hipobuyspread.rest';

const websiteLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Hipobuy Spreadsheet Hub",
  "url": SITE_URL,
  "description": "The Ultimate Product Finding Database - Discover organized product spreadsheets, category guides, and expert comparisons for smarter shopping.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${SITE_URL}/search?q={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
};

const organizationLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Hipobuy Spreadsheet Hub",
  "url": SITE_URL,
  "description": "Independent educational resource providing organized product discovery tools and shopping guides.",
  "sameAs": [
    "https://kaspreadsheet.com"
  ]
};

const webPageLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Hipobuy Spreadsheet Hub — The Ultimate Product Finding Database",
  "description": "Discover the most comprehensive Hipobuy Spreadsheet resource. Browse 14 product categories, curated guides, product comparison tools, and expert shopping tips for Hipobuy, Kakobuy, CSSBuy, Superbuy and Oopbuy users.",
  "url": SITE_URL,
  "isPartOf": {
    "@type": "WebSite",
    "name": "Hipobuy Spreadsheet Hub",
    "url": SITE_URL
  },
  "about": {
    "@type": "Thing",
    "name": "Product Finding Spreadsheet Database"
  }
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <FeatureCards />
        <CategoryGrid />
        <EditorialSection />
        <ReviewSection />
        <CTASection />
      </main>
      <FooterSection />
    </div>
  );
}